<template>
  <el-collapse v-model="filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="minimum-management-search-section" id="minimum-management-search-section">
      <el-form
        id="minimum-search-section-form"
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('Name Contact')">
              <el-input
                  v-model="searchForm.contactName"
                  popper-class="autocomplete-popper"
                  ref="autocomplete-principal"
                  :placeholder="$t('account.contactInfo.name')"
                  @input="handleSearch"
                  >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('Type')">
              <select-list-billing
                  :value.sync="searchForm.contactType"
                  :data="contactTypes"
                  :default-all="true"
                  label-field="label"
                  value-field="value"
                  ref="filter-region-select"
                  @change="handleSearch" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('Status')">
              <select-list-billing
                  :value.sync="searchForm.contactStatus"
                  :data="contactStatuses"
                  label-field="label"
                  value-field="value"
                  ref="filter-region-select"
                  @change="handleSearch" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              :content="$t('common.search')"
              class="item"
              effect="dark"
              placement="top-start"
            >
              <el-button
                id="invoices-search-section-form-button"
                class="button-action-default"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import { ACCOUNT_SEARCH_CONTACT_INFO } from '@/store/actions';
import constants from '@/utils/constants';
// import apiConstants from '@/utils/apiConstants';
// import Autocomplete from '@/components/Autocomplete';
//  import ExpiredSelect from './components/expiredService/ExpiredServiceSelect';
import SelectListBilling from '@/components/billing/SelectListBilling/SelectListBilling';

export default {
  name: 'SearchFilters',
  components: {
    SelectListBilling // , Autocomplete
  },
  computed: {
    ...mapGetters(['customerMasterRecord']),
    customerId() {
      return this.customerMasterRecord.list[0]?.id || null;
    },
  },
  data() {
    return {
      filtersOpen: ['customer-management-search-section'],
      searchForm: {
        contactType: 'ALL',
        contactName: null,
        contactStatus: 'ACTIVE'
      },
      contactTypes: constants.ACCOUNTS.CONTACT_TYPES,
      contactStatuses: constants.ACCOUNTS.CONTACT_STATUSES

    };
  },
  methods: {
    handleSearch() {
      const filters = {
        contactType: this.searchForm.contactType || 'ALL',
        contactName: this.searchForm.contactName,
        statusFilter: this.searchForm.contactStatus || 'ACTIVE'
      };
      this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: this.customerId, filters });
    }
  }
};
</script>
